export const supportedLanguages = ["en-us"];
